var map = {
	"./al-ritrovo.webp": 83327,
	"./casa-df.webp": 82171,
	"./casa-ra-f.webp": 80038,
	"./casa-sc.webp": 34735,
	"./casa-tb.webp": 70241,
	"./cattedrale.webp": 97073,
	"./contatti.webp": 38073,
	"./frette-agira.webp": 48156,
	"./frette-caserta.webp": 39521,
	"./frette-noventa.webp": 61476,
	"./garden.webp": 75926,
	"./interior-design.webp": 46202,
	"./maria-aiello-hairstyle.webp": 79192,
	"./me4.webp": 75890,
	"./palco.webp": 19605,
	"./projects.webp": 91726,
	"./rampa.webp": 24908,
	"./villa-gerace.webp": 55883,
	"./volpe-gioielli.webp": 98391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69876;